import React, { useEffect, useRef } from 'react';
import './Sidebar.css';

const Sidebar = ({ isOpen, toggleSidebar, isLoggedIn, onLogout }) => {
  const isAdmin = localStorage.getItem('is_admin') === '1'; // Check admin status
  const sidebarRef = useRef(null);
  const menuButtonRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      console.log("Click detected outside sidebar!");

      if (!isOpen) {
        console.log("Sidebar already closed, ignoring click.");
        return;
      }

      console.log("Sidebar Ref:", sidebarRef.current);
      console.log("Menu Button Ref:", menuButtonRef?.current);
      console.log("Clicked Element:", event.target);

      // Ensure refs exist before accessing `current`
      if (
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target)
      ) {
        toggleSidebar(); // Close sidebar
      }
    };

    // Attach event listener only if sidebar is open
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, toggleSidebar, menuButtonRef]); // Ensure dependencies are properly tracked
  

  return (
    <>
      <div ref={sidebarRef} className={`sidebar ${isOpen ? 'open' : 'collapsed'}`}>
        <nav>
          <ul>
            <li><a href="/"><i className="icon-home"></i><span>Home</span></a></li>
            <li><a href="/ashrae15"><i className="icon-dashboard"></i><span>Commercial</span></a></li>
            <li><a href="/ashrae152"><i className="icon-dashboard"></i><span>Residential</span></a></li>
            {isLoggedIn && (
              <>
                <hr className="sidebar-divider" />
                <li><a href="/MyAccount"><i className="icon-user"></i><span>My Account</span></a></li>
                {isAdmin && (
                  <li><a href="/Admin"><i className="icon-admin"></i><span>Admin</span></a></li>
                )}
                <li><button onClick={onLogout} className="logout-btn"><i className="icon-logout"></i><span>Logout</span></button></li>
              </>
            )}
          </ul>
        </nav>
      </div>
    </>
  );
};

export default Sidebar;
